import { api } from "../../ConsumeApiController";
import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";

export async function getEvents(status)
{
    let url = '';
    if(status)
        url = CompanyRoutes.Events.GetAll(status);
    else
        url = CompanyRoutes.Events.GetAll('all');
    
    const response = await api.get(url);
    
    if(response.success === true)
    {
        const {events} = response.data;
        return {events};
    }
    else
    {
        return {events:[]}
    }
}

export async function GetEvent(id)
{
    let response = await api.get(CompanyRoutes.Events.Show(id));
    return response;
}



export async function getEventDashboardStats(eventId)
{
    const response = await api.get(CompanyRoutes.Events.GetEventStats(eventId));
    return response;
}

export async function getBoxOfficeEventDetails(eventId)
{
    const response = await api.get(CompanyRoutes.Events.GetEvent(eventId));
    return response;
}



